import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBrain, faComments, faCogs, faRoute, faChartBar } from '@fortawesome/free-solid-svg-icons';
import '../../styles/logistic/LogisticFeaturesSection.css';
import chatbotFeatures from "../../assets/app/Logistic/chatbot-features-es.png";
import { useTranslation } from 'react-i18next';

const LogisticFeaturesSection: React.FC = () => {
  const { t } = useTranslation();

  return (
    <section className="logistic-features-section">
      <div className="logistic-container">
        <div className="logistic-section-header">
          <span className="logistic-section-tag">{t('LogisticFeaturesSection:section_tag')}</span>
          <h2>
            {t('LogisticFeaturesSection:title_prefix')}{' '}
            <span className="logistic-text-primary">{t('LogisticFeaturesSection:title_strong')}</span>{' '}
            {t('LogisticFeaturesSection:title_suffix')}
          </h2>
          <p>{t('LogisticFeaturesSection:subtitle')}</p>
        </div>
        
        <div className="logistic-features-image-container">
          <img src={chatbotFeatures} alt={t('LogisticFeaturesSection:alt_text')} loading="lazy" className="logistic-features-image" />
        </div>
        
        <div className="logistic-features-grid">
          <div className="logistic-feature-item-detail">
            <div className="logistic-feature-icon-large">
              <FontAwesomeIcon icon={faBrain} />
            </div>
            <h3>{t('LogisticFeaturesSection:feature1_title')}</h3>
            <p>{t('LogisticFeaturesSection:feature1_text')}</p>
          </div>
          
          <div className="logistic-feature-item-detail">
            <div className="logistic-feature-icon-large">
              <FontAwesomeIcon icon={faComments} />
            </div>
            <h3>{t('LogisticFeaturesSection:feature2_title')}</h3>
            <p>{t('LogisticFeaturesSection:feature2_text')}</p>
          </div>
          
          <div className="logistic-feature-item-detail">
            <div className="logistic-feature-icon-large">
              <FontAwesomeIcon icon={faCogs} />
            </div>
            <h3>{t('LogisticFeaturesSection:feature3_title')}</h3>
            <p>{t('LogisticFeaturesSection:feature3_text')}</p>
          </div>
          
          <div className="logistic-feature-item-detail">
            <div className="logistic-feature-icon-large">
              <FontAwesomeIcon icon={faRoute} />
            </div>
            <h3>{t('LogisticFeaturesSection:feature4_title')}</h3>
            <p>{t('LogisticFeaturesSection:feature4_text')}</p>
          </div>
          
          <div className="logistic-feature-item-detail">
            <div className="logistic-feature-icon-large">
              <FontAwesomeIcon icon={faChartBar} />
            </div>
            <h3>{t('LogisticFeaturesSection:feature5_title')}</h3>
            <p>{t('LogisticFeaturesSection:feature5_text')}</p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default LogisticFeaturesSection;